import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogClose, MatDialogContent, MatDialogTitle } from "@angular/material/dialog";
import { PdfViewerModule } from "ng2-pdf-viewer";
import { MatIcon } from "@angular/material/icon";
import { MatIconButton } from "@angular/material/button";

@Component({
	selector: "app-pdf-viewer",
	imports: [MatDialogTitle, MatDialogContent, PdfViewerModule, MatDialogClose, MatIcon, MatIconButton],
	templateUrl: "./pdf-viewer.component.html",
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrl: "./pdf-viewer.component.scss",
})
export class PdfViewerComponent {
	data = inject<Uint8Array>(MAT_DIALOG_DATA);
}
